/**
 * @generated SignedSource<<073fee0e970f27a6ec41c2c3acf68639>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableDetailsTabs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedItemDetails_user" | "PdpRespSharedSellerDetails_user">;
  readonly " $fragmentType": "PdpRespUnavailableDetailsTabs_user";
};
export type PdpRespUnavailableDetailsTabs_user$key = {
  readonly " $data"?: PdpRespUnavailableDetailsTabs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableDetailsTabs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableDetailsTabs_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedSellerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedItemDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9092ff8cba85822df009ff538b47a034";

export default node;
